import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

/**
 * Main application entry point
 * 
 * No dependency on router-fix.js
 * Proper error handling to show meaningful errors
 */
console.log('[App Init] Starting ModularCompliance application...');

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('[React Error] Root element not found!');
} else {
  try {
    console.log('React version:', React.version);
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('[React Error] Failed to render app:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    const errorStack = error instanceof Error ? error.stack : 'Stack trace not available';
    rootElement.innerHTML = `
      <div style="padding: 20px; color: red; font-family: sans-serif;">
        <h1>React Rendering Error</h1>
        <p>${errorMessage}</p>
        <pre style="background:#f8f8f8; padding:10px; overflow:auto;">${errorStack}</pre>
      </div>
    `;
  }
}
